export default __webpack_public_path__ + "static/media/Flag_of_Tanzania.8dbfdde9.svg";